import { MenuAction } from '@ordr-as/umami-react/context-menu';
import { getAdminUrl } from '../../utils/url-builder';
import { FormattedMessage } from 'react-intl';
import ExternallinkIcon from '@ordr-as/icons/ExternallinkIcon';
import { useSoftpayAppId } from '../../context/SoftpayAppIdStore';
import useDeviceId from '../../hooks/useDeviceId';

interface Props {
  locationId: number | undefined;
}

const AdminRedirect = ({ locationId }: Props) => {
  const deviceId = useDeviceId();
  const softpayAppId = useSoftpayAppId();

  const isTerminal = deviceId || softpayAppId;

  return (
    <MenuAction
      className="border-b border-grey-lightest !py-3"
      onClick={() => {
        if (isTerminal) {
          window.location.href = getAdminUrl(locationId);
        } else {
          window.open(getAdminUrl(locationId), '_blank');
        }
      }}
    >
      <div className="flex w-full items-center justify-between text-base text-brand-black">
        <FormattedMessage id="header.admin" />
        <ExternallinkIcon width={20} height={20} />
      </div>
    </MenuAction>
  );
};

export default AdminRedirect;
